import PageHeader from "../../../components/common/PageHeader";
import ContactForm from "../components/ContactForm";

const CreateContact = () => {
  return (
    <>
      <PageHeader
        title="Create Contact"
        breadcrumbs={[
          { label: "Masters" },
          { label: "Contact Directory", path: "/masters/contact" },
          { label: "Create Contact" },
        ]}
      />

      <div className="container mt-4">
        <ContactForm />
      </div>
    </>
  );
};

export default CreateContact;